module.exports = __webpack_public_path__ + "img/dhg_fun.b037f574.jpg";